/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied and modified from 'antd/lib/menu/SubMenu.tsx';
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import { MenuContext as RcMenuContext } from 'rc-menu/es/context/MenuContext';
import { SubMenu as RcSubMenu, useFullPath } from 'rc-menu';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import MenuContext from './MenuContext';
import { isValidElement, cloneElement } from '../_util/reactNode';
const SubMenu = (props) => {
    const { mode, expandIcon } = React.useContext(RcMenuContext);
    const { title: customizeTitle, popupClassName, icon, ...otherProps } = props;
    // B-Design: Append the expandIcon to title because RcMenu Submenu does not support expandIcon in `horizontal` mode.
    // See https://github.com/react-component/menu/blob/master/src/SubMenu/index.tsx#L269
    let title = customizeTitle;
    if (mode === 'horizontal' && expandIcon) {
        title = (React.createElement(React.Fragment, null,
            customizeTitle,
            " ",
            expandIcon));
    }
    const context = React.useContext(MenuContext);
    const { prefixCls, inlineCollapsed, antdMenuTheme } = context;
    const parentPath = useFullPath();
    let titleNode;
    if (!icon) {
        titleNode =
            inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? (React.createElement("div", { className: `${prefixCls}-inline-collapsed-noicon` }, title.charAt(0))) : (React.createElement("span", { className: `${prefixCls}-title-content` }, title));
    }
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = isValidElement(title) && title.type === 'span';
        titleNode = (React.createElement(React.Fragment, null,
            cloneElement(icon, {
                className: classNames(isValidElement(icon) ? icon.props?.className : '', `${prefixCls}-item-icon`)
            }),
            titleIsSpan ? title : React.createElement("span", { className: `${prefixCls}-title-content` }, title)));
    }
    const contextValue = React.useMemo(() => ({
        ...context,
        firstLevel: false
    }), [context]);
    return (React.createElement(MenuContext.Provider, { value: contextValue },
        React.createElement(RcSubMenu, { ...omit(props, ['icon']), title: titleNode, popupClassName: classNames(prefixCls, `${prefixCls}-${antdMenuTheme}`, popupClassName) })));
};
// export default withConfigProvider(SubMenu);
export default SubMenu;
